"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import {
  Carousel,
  type CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { cn } from "@/lib/_utils";
import { TRADIES } from "./data";

export function HomeV2Tradies() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => setCurrent(api.selectedScrollSnap()));
  }, [api]);

  return (
    <section className="bg-white px-4 py-20 sm:px-6 lg:px-8">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center">
        <div className="mx-auto max-w-[1056px] text-center">
          <h2 className="font-bold text-[#2C2C2C] text-[56px] leading-[1.1] tracking-[-0.02em] max-lg:text-4xl">
            Get to know our Tradies
          </h2>
          <div aria-hidden className="h-6" />
          <p className="mx-auto max-w-[989px] font-normal text-[#3F474E] text-xl leading-[1.4]">
            Receive professional guidance and assistance for your home projects
            with Teletradie. From home repairs to interior design, we have all
            your needs covered!
          </p>
        </div>

        <div aria-hidden className="h-12" />

        {/* Figma: 443px cards, 36px gap, image ~372px / radius 30 */}
        <Carousel
          className="w-full"
          opts={{ align: "start", loop: true }}
          setApi={setApi}
        >
          <CarouselContent className="-ml-0 lg:-ml-9">
            {TRADIES.map((tradie) => (
              <CarouselItem
                className="basis-[85%] pl-0 sm:basis-[55%] md:basis-[443px] lg:pl-9"
                key={tradie.id}
              >
                <article className="flex w-full max-w-[443px] flex-col items-center">
                  <div className="relative h-[280px] w-full overflow-hidden rounded-[30px] sm:h-[320px] lg:h-[372px]">
                    <Image
                      alt={`${tradie.title} with ${tradie.name}`}
                      className="object-cover"
                      fill
                      sizes="443px"
                      src={tradie.image}
                    />
                  </div>

                  <div aria-hidden className="h-6" />

                  <div className="flex max-w-[231px] flex-col items-center text-center">
                    <h3 className="font-bold text-[#2C2C2C] text-[28px] leading-[1.3]">
                      {tradie.title}
                    </h3>
                    <div aria-hidden className="h-2" />
                    <p className="font-normal text-[#3F474E] text-lg leading-[1.4]">
                      with {tradie.name}
                    </p>
                  </div>
                </article>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>

        <div className="mt-10 flex justify-center gap-2">
          {TRADIES.map((tradie, index) => (
            <button
              aria-label={`Go to tradie ${index + 1}`}
              className={cn(
                "size-2 cursor-pointer rounded-full transition-colors",
                current === index
                  ? "bg-[#0586D7]"
                  : "bg-[#C4C4C4] hover:bg-[#9FB3C8]"
              )}
              key={tradie.id}
              onClick={() => api?.scrollTo(index)}
              type="button"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
